import React from "react";
import {connect, DispatchProp} from "react-redux";
import {loadScene} from "../../store/routing/actions";
import styles from "./leaderboards.module.css";
import listViewStyles from "../../shared/components/list-view/list-view.module.css";
import {IApplicationState} from "../../store";
import renderText from "../../shared/components/renderText";
import {ListViewProps, ListViewState} from "../../shared/components/list-view/ListView";
import {memoize} from "../../shared/utils/memoize";
import {cssHelper} from "../../shared/utils/cssHelper";
import {trackError} from "../../store/log/actions";
import {ListViewScene} from "../../shared/components/list-view/ListViewScene";
import i18n from "../../shared/i18n";
import {ICanvasDimensions} from "../../store/settings/types";
import { ILeaderboardEntry } from "../../sdk/types";
import { SDK } from "../../sdk";

const SCROLL_OFFSET = 600;
const PAGE_SIZE = 100;

interface LeaderboardsSceneProps extends DispatchProp, ListViewProps {
    playerId?: string;
    canvas: ICanvasDimensions;
}

interface LeaderboardsSceneState extends ListViewState<ILeaderboardEntry> {
    playerEntry: ILeaderboardEntry | null,
}

class LeaderboardsScene extends ListViewScene<ILeaderboardEntry, LeaderboardsSceneProps, LeaderboardsSceneState> {
    constructor(props: LeaderboardsSceneProps, context: any) {
        super(props, context);

        this.loadPageInternal = memoize(this.loadPageInternal.bind(this));
    }

    renderEntries() {
        const entries = super.renderEntries();
        const visibleCount = Math.ceil((this.props.canvas.height - 145) / 100);
        const playerScore = this.state.playerEntry && this.state.playerEntry.rank > visibleCount
            ? this.renderEntry(this.state.playerEntry)
            : undefined;

        return (
            <>
                {playerScore}
                {entries}
            </>
        )
    }

    renderEntry(entry: ILeaderboardEntry) {
        const rank = entry.rank;

        return (
            <div key={rank} className={cssHelper(listViewStyles.entry).add(styles.current_player, entry.playerId === this.props.playerId).toString()}>
                {renderText("" + rank, 20, 48, 3, 7, styles.rank)}
                <div className={listViewStyles.picture} style={{ backgroundImage: `url('${entry.playerPicture}')`}}/>
                <div className={listViewStyles.entry_data}>
                    {renderText(entry.playerName, 28, 34, 24, 36, listViewStyles.entry_name)}
                    {renderText("" + entry.score, 20, 24, 30, 50, listViewStyles.entry_description)}
                </div>
            </div>
        );
    }

    getNoDataText() {
        return i18n("hiscores.nodata");
    }

    getHeader() {
        return i18n("hiscores.header");
    }

    async loadPageInternal(page: number) {
        const entries = await SDK.instance.getLeaderboardEntries(page, this.props.pageSize);

        return {
            entries,
            state: {
                playerEntry: this.state.playerEntry
            }
        }
    }

    getInitialState() {
        return {
            ...super.getInitialState(),
            playerEntry: null
        };
    }

    back() {
        super.back();
        this.props.dispatch(loadScene.request("MainMenu"));
    }

    protected trackError(message: string, error?: Error) {
        this.props.dispatch(trackError({
            category: "LeaderboardsScene",
            message: message,
            error: error,
        }));
    }
}

export default connect(({ player, settings }: IApplicationState) => ({
    playerId: player.id,
    canvas: settings.canvas,
    pageSize: PAGE_SIZE,
    scrollOffset: SCROLL_OFFSET,
}))(LeaderboardsScene);